<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Members</div>
              <q-btn
                v-if="
                  ['Club Admin', 'Coach', 'Team Manager'].includes(
                    currentUserData.role
                  ) && !currentUserData.currentAssociation.oa_id
                "
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 270px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-nfc" slot-scope="data">
                      <q-td :props="data.props">
                        <q-icon
                          name="mdi-nfc-variant"
                          class="cursor-pointer"
                          :class="{
                            'text-positive':
                              data.props.row.nfcTags &&
                              data.props.row.nfcTags.length > 0
                          }"
                          @click="startNFCScanner(data.props.row)"
                          size="sm"
                        >
                        </q-icon>
                      </q-td>
                    </template>
                    <template slot="body-cell-awards" slot-scope="data">
                      <q-td :props="data.props">
                        <q-icon name="mdi-file-certificate-outline" size="sm">
                          <q-tooltip>
                            <div>
                              <div>Player Awards</div>
                              <div
                                v-if="data.props.row.awards.length > 0"
                                v-for="(award, index) in data.props.row.awards"
                                :key="`award_${index}`"
                              >
                                {{ award.shortName }}
                              </div>
                              <div v-if="data.props.row.awards.length < 1">
                                No Awards
                              </div>
                            </div>
                          </q-tooltip>
                        </q-icon>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <!-- <q-btn>Test</q-btn> -->
                        Coming soon!
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="90vw">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">New Member</div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <memberForm
              ref="newForm"
              addMember
              @close="
                newDialog = false;
                loadData();
              "
              @loadingStateChanged="state => (createLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.addMemberToAssociation()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="90vw">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Member</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <memberForm
              ref="editMemberForm"
              :id="$route.params.member_id"
              @close="close"
              @loadingStateChanged="state => (saveLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editMemberForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import memberForm from "@/components/users/memberForm.vue";
import moment from "moment";
import { NFCScan, NFCWrite } from "@/plugins/NFC";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    memberForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      gridData: "associations/members",
      dataLoading: "associations/membersLoading",
      divisions: "divisions/list"
    }),
    columns: function() {
      return [
        {
          name: "nfc",
          label: "NFC",
          align: "left",
          field: "nfc",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: row => row,
          format: val => `${val.firstName} ${val.lastName}`,
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "birthDate",
          label: "DOB",
          align: "left",
          field: "birthDate",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true
        },
        {
          name: "gender",
          label: "Gender",
          align: "left",
          field: "gender",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true
        },
        {
          name: "division",
          label: "Division",
          align: "left",
          field: "birthDate",
          format: (val, row) => {
            if (this.divisions) {
              let year = moment().format("YYYY");
              let reference = moment(`${year}-09-30`);
              if (moment(`${year}-07-01`) > moment()) {
                reference = reference.subtract(1, "years");
              }
              let age = reference.diff(val, "years", false);
              let div = this.divisions.find(
                d =>
                  d.division_age_min <= age &&
                  d.age_max >= age &&
                  row.gender == d.gender
              );
              return div ? div.division_name : "No Division";
            } else {
              return "";
            }
          },
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sort: (a, b, rowA, rowB) => {
            let year = moment().format("YYYY");
            let reference = moment(`${year}-09-30`);
            if (moment(`${year}-07-01`) > moment()) {
              reference = reference.subtract(1, "years");
            }

            let ageA = reference.diff(rowA.birthDate, "years", false);
            let ageB = reference.diff(rowB.birthDate, "years", false);

            if (ageA == ageB) {
              return rowA.gender.localeCompare(rowB.gender);
            } else {
              return ageA - ageB;
            }
          },

          sortable: true
        },
        {
          name: "mobilePhone",
          label: "Mobile Phone",
          align: "left",
          field: "mobilePhone",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true
        }
        // {
        //   name: "actions",
        //   label: "Actions",
        //   align: "left",
        //   sortable: false,
        // },
      ];
    }
  },
  data: () => ({
    // data-table

    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    nfcScanner: null,

    ndef: null,
    handleReading: null
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
  },
  methods: {
    handleDoubleClick(row) {
      if (this.currentUserData.role != "Sport Manager") {
        this.$router.push(`${this.$route.path}/${row.id}`);
      }
    },
    loadData() {
      this.$store.dispatch("associations/loadMembersForAssociation", {
        id: this.currentUserData.currentAssociation_id
      });
      this.$store.dispatch("associations/loadMembers", {
        id: this.currentUserData.currentAssociation_id
      });
      this.$store.dispatch("divisions/loadAll");
    },
    handleRoute() {
      if (this.$route.params.member_id) {
        this.viewFormData = { id: this.$route.params.member_id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    async handleNFCScan(message, serialNumber, extraData) {
      this.ndef.removeEventListener("reading", this.handleReading);
      console.log(this.nfcScanner);

      // ADD NFC to Member
      try {
        let response = await this.$store.dispatch(
          "associations/addNFCToMember",
          {
            id: extraData.id,
            serialNumber: serialNumber,
            associations_id: this.currentUserData.currentAssociation_id
          }
        );
        if (!response.Response.Result) {
          this.$q.notify({
            position: "top-right",
            type: response.Response.Result ? "positive" : "negative",
            message: response.Response.Message
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async startNFCScanner(row) {
      const { ndef, handleReading } = await NFCScan(
        this,
        this.handleNFCScan,
        row
      );
      this.ndef = ndef;
      this.handleReading = handleReading;

      NFCWrite(
        this,
        `${row.firstName} ${row.lastName} - ${row.id} - ${row.crm_id} - ${row.association_name}`
      );
    },
    close() {
      this.$router.push("/entries/members");
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
